import { TruncateString } from 'foundations-components/transitional/components/TruncateString';
import { PreviewCardHeaderWrapper, PreviewCardNameWrapper } from './PreviewCardStyles';
import PreviewCardTimestamp from 'svh-workspace-ui-lib/preview-card/public/components/PreviewCardTimestamp';
import { EditIcon } from 'foundations-assets';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PreviewCardHeader = ({
  isUnread,
  isUnknownContact,
  text,
  renderAbsoluteTimestampOverride,
  timestamp,
  isNameHeader,
  isLatestMessageADraft
}) => {
  return /*#__PURE__*/_jsxs(PreviewCardHeaderWrapper, {
    "data-test-id": "member-header",
    isUnread: isUnread,
    children: [isNameHeader ? /*#__PURE__*/_jsx(PreviewCardNameWrapper, {
      isUnread: isUnread,
      isUnknownContact: isUnknownContact,
      children: /*#__PURE__*/_jsx(TruncateString, {
        tooltip: false,
        children: text
      })
    }) : /*#__PURE__*/_jsx(TruncateString, {
      children: text
    }), /*#__PURE__*/_jsxs(Flex, {
      display: "inline-flex",
      alignItems: "center",
      children: [/*#__PURE__*/_jsx(Flex, {
        flexDirection: "row",
        paddingInline: "100",
        gap: "100",
        children: isLatestMessageADraft && /*#__PURE__*/_jsx(EditIcon, {
          color: 'icon-core-subtle'
        })
      }), timestamp ? /*#__PURE__*/_jsx(PreviewCardTimestamp, {
        renderAbsoluteTimestampOverride: renderAbsoluteTimestampOverride,
        timestamp: timestamp
      }) : null]
    })]
  });
};
PreviewCardHeader.displayName = 'PreviewHeader';
export default PreviewCardHeader;